import React from 'react'

export interface LinkMatch {
  url: string
  start: number
  end: number
}

/**
 * Detecta URLs em um texto e retorna array de matches
 */
export function detectLinks(text: string): LinkMatch[] {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}[^\s]*)/g
  const matches: LinkMatch[] = []
  let match

  while ((match = urlRegex.exec(text)) !== null) {
    let url = match[0]
    
    // Adicionar protocolo se não tiver
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      if (url.startsWith('www.')) {
        url = 'https://' + url
      } else {
        url = 'https://' + url
      }
    }

    matches.push({
      url,
      start: match.index,
      end: match.index + match[0].length
    })
  }

  return matches
}

/**
 * Formata mensagem com links clicáveis
 */
export function formatMessageWithLinks(content: string): React.ReactNode {
  const links = detectLinks(content)
  
  if (links.length === 0) {
    return content
  }

  const parts: React.ReactNode[] = []
  let lastIndex = 0

  links.forEach((link, index) => {
    // Adicionar texto antes do link
    if (link.start > lastIndex) {
      parts.push(content.substring(lastIndex, link.start))
    }

    // Adicionar link
    parts.push(
      <a
        key={`link-${index}`}
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:text-blue-300 underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {content.substring(link.start, link.end)}
      </a>
    )

    lastIndex = link.end
  })

  // Adicionar texto restante
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex))
  }

  return <>{parts}</>
}

/**
 * Verifica se um texto contém links
 */
export function hasLinks(text: string): boolean {
  return detectLinks(text).length > 0
}
